import {
  Activity,
  Shift,
  UserTimelines,
  WithPreparedAttributes,
} from '@wilson/interfaces';

export function getFilteredUsersWithUpdatedShifts({
  users,
  shiftAssignments,
  shiftIdToShiftMap,
}: {
  users: UserTimelines[];
  shiftAssignments: Record<string, string[]>;
  shiftIdToShiftMap: Map<string, Shift>;
}): UserTimelines[] {
  return users
    .filter((user) =>
      Object.prototype.hasOwnProperty.call(shiftAssignments, user.id as string),
    )
    .map((user) => ({
      ...user,
      shifts: (shiftAssignments[user.id] || []).reduce(
        (
          accumulatedShifts: (Shift &
            WithPreparedAttributes & {
              id: string;
              activities: Activity[];
              priority: number | null;
            })[],
          shiftId,
        ) => {
          if (shiftIdToShiftMap.has(shiftId)) {
            accumulatedShifts.push({
              ...(shiftIdToShiftMap.get(shiftId) as Shift &
                WithPreparedAttributes & {
                  id: string;
                  activities: Activity[];
                  priority: number | null;
                }),
              userId: user.id as string,
            });
          }

          return accumulatedShifts;
        },
        [],
      ),
    }));
}
